import { useState } from 'react';
import { deleteUserOfProfile } from '../../../Service/restapi/authService';
import { ConfirmDialog } from '../../../Molecules/Dialogs';
import { ActionIcon, Menu } from '@mantine/core';
import { IconDots } from '@tabler/icons';

export const ProfileShareActions = ({ email, reloadProfileShares }) => {
  const [modalDelete, setModalDelete] = useState(false);

  const items = [{ text: 'Freigabe entfernen', onClick: () => setModalDelete(!modalDelete) }];

  function deleteHandler() {
    deleteUserOfProfile(email)
      .then((resp) => {})
      .finally(() => {
        reloadProfileShares();
      });
  }

  return (
    <>
      <Menu radius="sm" shadow="md" transition="scale-y" position="bottom-end">
        <Menu.Target>
          <ActionIcon size="sm">
            <IconDots />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item onClick={() => setModalDelete(!modalDelete)}>Freigabe entfernen</Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <ConfirmDialog
        text="common.delete.profile.share.confirm"
        subject="common.delete.profile.share.head"
        open={modalDelete}
        toggle={() => setModalDelete(!modalDelete)}
        handler={deleteHandler}
      />
    </>
  );
};
